import type { CosignatureQueueSearchParams } from "@/core/types";

export const cosignatureKeys = {
  addendumMeta: (documentId: string) =>
    [...cosignatureKeys.base, "addendum", documentId, "meta"] as const,
  base: ["cosignature"] as const,
  noteMeta: (documentId: string) => [...cosignatureKeys.base, "note", documentId, "meta"] as const,
  queue: (searchParams?: CosignatureQueueSearchParams) =>
    [...cosignatureKeys.base, "queue", searchParams] as const,
  supervisors: () => [...cosignatureKeys.base, "supervisors"] as const,
} as const;
